<template>
  <div class="min-h-screen bg-gradient-to-br from-psychology-calm via-white to-psychology-warm">
    <!-- 顶部导航 -->
    <nav class="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div class="container mx-auto px-4 py-4">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <router-link to="/" class="inline-flex items-center gap-2 px-3 py-2 hover:bg-gray-100 rounded-md transition-colors text-gray-600 hover:text-gray-900">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8"></path>
                <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
              </svg>
            </router-link>
            <div class="flex items-center gap-2">
              <span class="text-2xl">💕</span>
              <span class="font-semibold text-psychology-primary">年上年下恋爱倾向测试</span>
            </div>
          </div>
          <button @click="goBack" class="hidden sm:inline-flex items-center gap-2 px-3 py-2 border border-gray-300 bg-white hover:bg-gray-50 rounded-md transition-colors text-gray-600">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
              <path d="m12 19-7-7 7-7"></path>
              <path d="M19 12H5"></path>
            </svg>
          </button>
        </div>
      </div>
    </nav>

    <!-- 主要内容 -->
    <main class="container mx-auto px-4 py-8">
      <div class="max-w-4xl mx-auto space-y-6">
        <!-- 页面标题 -->
        <div class="text-center">
          <h1 class="text-3xl font-bold text-psychology-primary mb-2">选择测试类型</h1>
          <p class="text-gray-600 text-lg">请选择你想要进行的测试类型</p>
        </div>

        <!-- 测试类型选择卡片 -->
        <div class="card p-8">
          <TestTypeSelector v-model="selectedTestType" />
        </div>

        <!-- 继续按钮 -->
        <div class="text-center">
          <button 
            @click="continueToStart"
            :disabled="!selectedTestType"
            :class="[
              'px-12 py-4 text-lg font-semibold rounded-lg transition-all inline-flex items-center gap-2',
              selectedTestType
                ? 'bg-psychology-primary text-white hover:bg-psychology-primary/90 hover:shadow-lg hover:-translate-y-0.5 cursor-pointer' 
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            ]"
          >
            <span>继续</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 12h14"></path>
              <path d="m12 5 7 7-7 7"></path>
            </svg>
          </button>
          <!-- 提示文字 -->
          <div 
            class="hint-message"
            :class="{ 'hint-visible': !selectedTestType, 'hint-hidden': selectedTestType }"
          >
            <p class="text-sm text-gray-500 mt-3">
              请先选择测试类型
            </p>
          </div>
        </div>
      </div>
    </main>

    <!-- 回到顶部 -->
    <BackToTop />
  </div>
</template>

<script>
import BackToTop from '../components/BackToTop.vue'
import TestTypeSelector from '../components/TestTypeSelector.vue'

export default {
  name: 'TestTypeSelectionPage',
  components: {
    BackToTop,
    TestTypeSelector
  },
  data() {
    return {
      selectedTestType: ''
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    continueToStart() {
      if (!this.selectedTestType) {
        this.$toast?.warning('请先选择测试类型')
        return
      }
      
      // 跳转到开始测试页面，携带测试类型参数
      this.$router.push({
        path: '/assessment/start',
        query: {
          testType: this.selectedTestType
        }
      })
    }
  }
}
</script>

<style scoped>
.card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

/* 提示文字样式：避免布局跳动 */
.hint-message {
  min-height: 1.5rem;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
}

.hint-visible {
  opacity: 1;
  visibility: visible;
}

.hint-hidden {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}
</style>

